module.exports = __webpack_public_path__ + "img/hired.c95b4ce1.svg";